<div fxLayout="column" class="m-t">
    @for (ctrl of controls(); track $index) {
        <div
            data-testid="start-screen-condition-element"
            fxLayout="row"
            fxLayoutAlign="start center"
            fxLayoutGap="12px"
            class="p-t cipo--border-top--solid">
            <span fxFlex="6" class="additional-margin-for-alignment">
                @if ($index === 0) {
                    {{ "complexConditions.general.if" | translate }}
                } @else {
                    {{ "complexConditions.general.andIf" | translate }}
                }
            </span>
            <div fxFlex fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="8px">
                <span fxFlex="0 1 25" class="additional-margin-for-alignment">
                    {{ "complexConditions.general.startScreen" | translate }}
                </span>
                <cipo-select
                    data-testid="start-screen-condition-field-select"
                    fxFlex="0 1 25"
                    fxFlex.lt-xl="32"
                    fxFlex.lt-lg="48"
                    [control]="ctrl.operatorControl" />

                @if (
                    operatorMap()[ctrl.selectedOperatorId]?.typeId === OperatorTypeIdEnum.Number &&
                    operatorMap()[ctrl.selectedOperatorId]?.displayTypeId === OperatorTypeDisplayIdEnum.TextOrNumber
                ) {
                    <cipo-number
                        data-testid="start-screen-condition-number-value"
                        fxFlex="1 1 auto"
                        [control]="ctrl.controlNumber" />
                }

                @if (
                    operatorMap()[ctrl.selectedOperatorId]?.typeId === OperatorTypeIdEnum.Text &&
                    operatorMap()[ctrl.selectedOperatorId]?.displayTypeId === OperatorTypeDisplayIdEnum.TextOrNumber
                ) {
                    <cipo-text
                        data-testid="start-screen-condition-text-value"
                        fxFlex="1 1 auto"
                        [control]="ctrl.controlText" />
                }

                @if (
                    operatorMap()[ctrl.selectedOperatorId]?.typeId === OperatorTypeIdEnum.Text &&
                    operatorMap()[ctrl.selectedOperatorId]?.displayTypeId === OperatorTypeDisplayIdEnum.Select
                ) {
                    @if (
                        !(
                            operatorMap()[ctrl.selectedOperatorId]?.key === OperatorTypeEnum.IsEmpty ||
                            operatorMap()[ctrl.selectedOperatorId]?.key === OperatorTypeEnum.IsNotEmpty
                        )
                    ) {
                        <cipo-select
                            data-testid="start-screen-condition-select-value"
                            fxFlex="1 1 auto"
                            [control]="ctrl.valueControl" />
                    }
                }

                @if (
                    operatorMap()[ctrl.selectedOperatorId]?.typeId === OperatorTypeIdEnum.Select &&
                    operatorMap()[ctrl.selectedOperatorId]?.displayTypeId === OperatorTypeDisplayIdEnum.TextOrNumber
                ) {
                    <cipo-checkbox
                        data-testid="start-screen-condition-checkbox-value"
                        fxFlex="1 1 auto"
                        [control]="ctrl.controlCheckbox" />
                }
            </div>
            <button
                data-testid="start-screen-condition-delete-button"
                class="additional-margin-for-alignment"
                fxFlex="none"
                mat-icon-button
                [title]="'general.delete' | translate"
                [attr.aria-label]="'general.delete' | translate"
                (click)="deleteStartScreenCondition($index)">
                <mat-icon aria-hidden="true">delete</mat-icon>
            </button>
        </div>
    }
</div>
